module.exports = __webpack_public_path__ + "img/page-desc-box.db25df38.png";